export default "__VITE_ASSET__D563f18Z__"